import React, { useContext } from 'react'
import { Heading } from '@pancakeswap/uikit'
import { Frame, Modal } from '@react95/core'
import { ArcadeContext } from 'Providers'

function GameModal() {
  const { currentGame, setCurrentGame } = useContext(ArcadeContext)
  const modalFrameStyle: any = {
    minWidth: '620px',
    backgroundColor: 'white',
    overflowY: 'scroll',
    padding: '8px',
  }
  const modalStyle: any = {
    margin: '16px',
    height: '580px',
    width: '640px',
    minWidth: '640px',
    maxWidth: '400px',
  }
  const iconStyle: any = { height: '14px', width: '14px', borderRadius: '4px' }

  return (
    <Modal
      defaultPosition={{ x: 12, y: 12 }}
      icon={<img src={currentGame.imgSrc} alt="" style={iconStyle} loading="lazy" />}
      title={currentGame?.title}
      width="50vw"
      height="50vh"
      closeModal={() => setCurrentGame(null)}
      style={modalStyle}
    >
      <Frame style={modalFrameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {currentGame?.title}
        </Heading>
        <iframe title="game-frame" loading="lazy" src={currentGame?.gameSrc} width="600" height="450" allowFullScreen />
      </Frame>
    </Modal>
  )
}

export default GameModal
